<template>
  <div class="panel">
    <div class="title">投放数据</div>
    <div class="condition">
      <div class="condition__info">
        <span class="condition__info__label"> 方案名称 </span>
        <el-input
          v-model="projectName"
          clearable
          placeholder="请输入方案名称"
          class="condition__info__data"
        />
      </div>
      <div class="condition__info">
        <span class="condition__info__label"> 投放时间 </span>
        <el-date-picker
          v-model="time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </div>
      <div class="condition__info">
        <span class="condition__info__label"> 状态 </span>
        <el-select v-model="status" clearable placeholder="请选择状态">
          <el-option
            v-for="(option, index) in statusList"
            :key="index"
            :label="option.value"
            :value="option.key"
          >
          </el-option>
        </el-select>
      </div>
      <el-button class="search" type="primary" @click="searchFn()"
        >搜索</el-button
      >
    </div>
    <div class="body">
      <el-tabs v-model="activeName">
        <el-tab-pane label="全部方案" name="allProject">
          <el-table
            :data="projectData"
            :border="false"
            :header-cell-style="{ background: '#EFF1F4' }"
            :fit="true"
            style="width: 100%"
          >
            <el-table-column align="left" label="下架/上线">
              <template #default="scope">
                <el-switch
                  :value="scope.row.whetherOrNot == 1"
                  @change="
                    switchProject(
                      scope.row.uid,
                      scope.row.whetherOrNot,
                      scope.row
                    )
                  "
                />
              </template>
            </el-table-column>
            <el-table-column align="left" label="方案名称" :width="secondWidth">
              <template #default="scope">
                <span
                  class="project_name"
                  @click="toAdvertisingDetails(scope.row.uid)"
                  >{{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="上线时间" width="310">
              <template #default="scope">
                <span>{{ scope.row.startTime }}至{{ scope.row.endTime }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="展示数">
              <template #default="scope">
                <span>{{ scope.row.advShow }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="曝光数">
              <template #default="scope">
                <span>{{ scope.row.advExposure }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="曝光数uv">
              <template #default="scope">
                <span>{{ scope.row.advExposureUv }} </span>
              </template>
            </el-table-column>

            <el-table-column align="right" label="阅读数">
              <template #default="scope">
                <span>{{ scope.row.advReading }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="点击数(pv)">
              <template #default="scope">
                <span>{{ scope.row.advPv }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="点击数(uv)">
              <template #default="scope">
                <span>{{ scope.row.advUv }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="转化数">
              <template #default="scope">
                <span>{{ scope.row.turnOverNum }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="3s以上">
              <template #default="scope">
                <span>{{ scope.row.advResidencetime }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template #default="scope">
                <div v-if="scope.row.status == 1" class="status_online">
                  {{ getStatusName(scope.row.status) }}
                </div>
                <div v-if="scope.row.status == 0" class="status_outline">
                  {{ getStatusName(scope.row.status) }}
                </div>
                <div v-if="scope.row.status == 2" class="status_beforeline">
                  {{ getStatusName(scope.row.status) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="90">
              <template #default="scope">
                <el-button
                  type="text"
                  @click="toPreview(scope.row.uid, scope.row.status)"
                  >查看</el-button
                >
                <el-button type="text" @click="deletePlatformFn(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @current-change="ProjectChangePage"
            :page-size="projectPageSize"
            :total="projectTotal"
            layout="total, ->, prev,pager, next"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="全部广告位" name="allAdvertising">
          <el-table
            :data="advertisingData"
            row-key="id"
            :header-cell-style="{ background: '#EFF1F4' }"
            style="width: 100%"
          >
            <el-table-column align="left" label="下架/上线">
              <template #default="scope">
                <el-switch
                  v-if="!scope.row.isChildren"
                  :value="scope.row.whetherOrNot == 1"
                  @change="
                    switchAdvertising(
                      scope.row.uid,
                      scope.row.whetherOrNot,
                      scope.row
                    )
                  "
                />
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              prop="locationName"
              label="广告名称"
              :width="secondWidth"
            >
            </el-table-column>
            <el-table-column align="left" :width="310" label="上线时间">
              <template #default="scope">
                <span v-if="!scope.row.isChildren"
                  >{{ scope.row.startTime }}至{{ scope.row.endTime }}
                </span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="轮播位">
              <template #default="scope">
                <span>{{ scope.row.name }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="展示数">
              <template #default="scope">
                <span>{{ scope.row.advShow }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="曝光数">
              <template #default="scope">
                <span>{{ scope.row.advExposure }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="曝光数uv">
              <template #default="scope">
                <span>{{ scope.row.advExposureUv }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="阅读数">
              <template #default="scope">
                <span>{{ scope.row.advReading }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="点击数(pv)">
              <template #default="scope">
                <span>{{ scope.row.advPv }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="点击数(uv)">
              <template #default="scope">
                <span>{{ scope.row.advUv }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="转化数">
              <template #default="scope">
                <span>{{ scope.row.turnOverNum }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="3s以上">
              <template #default="scope">
                <span>{{ scope.row.advResidencetime }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template #default="scope">
                <div v-if="scope.row.status == 1" class="status_online">
                  {{ getStatusName(scope.row.status) }}
                </div>
                <div v-if="scope.row.status == 0" class="status_outline">
                  {{ getStatusName(scope.row.status) }}
                </div>
                <div v-if="scope.row.status == 2" class="status_beforeline">
                  {{ getStatusName(scope.row.status) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" :width="50">
              <template #default="scope">
                <el-button
                  v-if="!scope.row.isChildren"
                  type="text"
                  @click="toEdit(scope.row.templateUid, scope.row.status)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @current-change="advertisingChangePage"
            :page-size="advertisingPageSize"
            layout="total, ->, prev, pager, next"
            :total="advertisingTotal"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getProjects, updateWhetherOrNotProject, updateWhetherOrNotTargetLocationMapping, getAllTargetLocationMappingDto } from '../../API/dropData'
import { deleteTemplate } from '../../API/template'
import _ from 'lodash'
export default {
  data () {
    return {
      projectName: '',
      time: '',
      status: '',
      templateTypes: [],
      activeName: 'allProject',
      advertisingNumber: 0,
      advertisingPageSize: 8,
      advertisingPages: 1,
      advertisingTotal: 1,
      advertisingData: [
        {
          switch: false,
          name: 'aaa',
          time: 'aaatobbb',
          showNum: '12',
          readNum: '14',
          pv: '12',
          uv: '13',
          clicknum: '42',
          urnoverNum: '52',
          status: 'online'
        }
      ],
      projectPageNumber: 0,
      projectPageSize: 8,
      projectPages: 1,
      projectTotal: 1,
      secondWidth: 0,
      projectData: [
      ],
      statusList: []
    }
  },
  created () {
    this.ProjectChangePage(1)
    this.advertisingChangePage(1)
  },
  mounted () {
    this.advertisingChangePage(1)
  },
  watch: {
    activeName () {
      this.$nextTick(() => {
        this.adjustColumnWidth()
      })
    }
  },
  methods: {
    adjustColumnWidth () {
      this.secondWidth = 0
      this.otherWidth = []
      const colgroup = document.querySelector('#pane-' + this.activeName + ' .el-table').querySelector('colgroup')
      const colDefs = [...colgroup.querySelectorAll('col')]
      var colDef = colDefs[1]
      const clsName = colDef.getAttribute('name')
      const cells = [
        ...document.querySelectorAll(`td.${clsName}`)
      ]
      const widthList = cells.map((el) => {
        return el.querySelector('.cell') ? el.querySelector('.cell').scrollWidth : 0
      })
      const max = Math.max(...widthList)
      const padding = 32
      this.secondWidth = max + padding
    },
    searchFn () {
      this.ProjectChangePage(1)
      this.advertisingChangePage(1)
    },
    getStatusName (status) {
      if (this.statusList.find(item => item.key === status)) {
        return this.statusList.find(item => item.key === status).value
      } else {
        return ''
      }
    },
    toAdvertisingDetails (templateUid) {
      this.$router.push(`/advertising-list/${templateUid}`)
    },
    toPreview (templateUid) {
      this.$router.push({
        path: `/create-project/preview/${templateUid}`
      })
    },
    toEdit (templateUid, state) {
      if (state === '已投放') {
        this.$message.error('正在投放的广告无法编辑，请先暂停投放')
        return
      }
      this.$router.push(`/create-project/edit/${templateUid}`)
    },
    async advertisingChangePage (pageNum = this.advertisingNumber) {
      const data = {
        pageNum,
        pageSize: this.advertisingPageSize
      }
      if (this.projectName !== '') {
        data.name = this.projectName
      }
      if (this.time !== '') {
        data.startTime = dayjs(this.time[0]).format('YYYY/MM/DD HH:mm:ss')
        data.endTime = dayjs(this.time[1]).format('YYYY/MM/DD HH:mm:ss')
      }
      if (this.status !== '') {
        data.status = this.status
      }
      const res = await getAllTargetLocationMappingDto(data)
      const list = res.pageInfo.list
      list.forEach(item => {
        if (item.buryPointRecordRelationTreeDtoList) {
          item.children = item.buryPointRecordRelationTreeDtoList.map(f => {
            return { ...f, id: f.sourceUid + '-' + f.sourceParentUid, isChildren: true }
          })
          item.name = '共' + item.children.length + '个'
        }
        item.id = item.uid + '-' + item.templateUid
      })
      this.advertisingPageSize = res.pageInfo.pageSize
      this.advertisingNumber = res.pageInfo.pageNum
      this.advertisingPages = res.pageInfo.pages
      this.advertisingData = list
      this.advertisingTotal = res.pageInfo.total
    },
    async deletePlatformFn (info) {
      const { name, uid } = info
      this.$confirm('删除后无法复原', `确认删除${name}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteTemplate({ templateUid: uid })
        console.log('res', res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '方案正在投放中，无法删除'
          })
          return
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        if (this.projectPageNumber > 1) {
          if (this.projectData.length > 1) {
            this.ProjectChangePage(this.projectPageNumber)
          } else {
            this.ProjectChangePage(this.projectPageNumber - 1)
          }
        } else {
          this.ProjectChangePage(1)
        }
        // this.advertisingChangePage(1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async ProjectChangePage (pageNum = this.projectPageNumber) {
      const data = {
        pageNum,
        pageSize: this.projectPageSize
      }
      if (this.projectName !== '') {
        data.name = this.projectName
      }
      if (this.time !== '') {
        data.startTime = dayjs(this.time[0]).format('YYYY/MM/DD HH:mm:ss')
        data.endTime = dayjs(this.time[1]).format('YYYY/MM/DD HH:mm:ss')
      }
      if (this.status !== '') {
        data.status = this.status
      }
      const res = await getProjects(data)
      this.projectPageSize = res.pageInfo.pageSize
      this.projectPageNumber = res.pageInfo.pageNum
      this.projectPages = res.pageInfo.pages
      this.projectData = res.pageInfo.list
      this.projectTotal = res.pageInfo.total
      this.templateTypes = res.templateTypes
      const status = []
      _.map(res.templateTypes, (key, value) => {
        status.push({
          key,
          value
        })
      })
      this.statusList = status
      this.$nextTick(() => {
        this.adjustColumnWidth()
      })
    },
    async switchAdvertising (targetLocationMappingUid, whetherOrNot, info) {
      if (whetherOrNot === 1) {
        this.$confirm(`暂停后,${info.locationName}广告位会被暂停投放`, `确认暂停${info.locationName}广告位？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const data = await updateWhetherOrNotTargetLocationMapping({ targetLocationMappingUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })
          if (data === '操作完成') {
            this.$notify({
              title: '成功',
              message: data,
              type: 'success'
            })
          }
          this.advertisingChangePage()
          // const i = this.advertisingData.findIndex(item => item.uid === targetLocationMappingUid)
          // this.advertisingData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        const data = await updateWhetherOrNotTargetLocationMapping({ targetLocationMappingUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })
        if (data === '操作完成') {
          this.$notify({
            title: '成功',
            message: data,
            type: 'success'
          })
        }
        this.advertisingChangePage()
        // const i = this.advertisingData.findIndex(item => item.uid === targetLocationMappingUid)
        // this.advertisingData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
      }
    },
    async switchProject (templateUid, whetherOrNot, info) {
      if (whetherOrNot === 1) {
        this.$confirm('暂停后方案下的广告位都会被同时暂停投放', `确认暂停方案${info.name}？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const data = await updateWhetherOrNotProject({ templateUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })

          if (data === '操作成功') {
            this.$notify({
              title: '成功',
              message: data,
              type: 'success'
            })
          }
          this.ProjectChangePage()
          // const i = this.projectData.findIndex(item => item.uid === templateUid)
          // this.projectData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        const data = await updateWhetherOrNotProject({ templateUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })
        if (data === '操作成功') {
          this.$notify({
            title: '成功',
            message: data,
            type: 'success'
          })
        }
        this.ProjectChangePage()
        // const i = this.projectData.findIndex(item => item.uid === templateUid)
        // this.projectData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
      }
    }
  }
}
</script>

<style lang="less">
.el-switch.is-checked .el-switch__core {
  border-color: #2878ff;
  background-color: #2878ff;
}
.el-table__expand-icon {
  position: absolute;
  right: -8px;
}
.el-pager li.active,
.el-tabs__item.is-active {
  color: #2878ff;
}
.el-button--text {
  color: #255aff;
  font-weight: 400;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
td {
  padding: 6px 0 !important;
  box-sizing: border-box;
  height: 44px;
}
.search {
  width: 96px;
  height: 32px;
  position: relative;
  background: #2878ff;
  & > span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
td:nth-child(2) .cell {
  overflow: auto !important;
  display: inline-block;
}
</style>
<style lang="less" scoped>
.status_online {
  color: var(--success);
  font-size: 14px;
  background-color: var(--light-success);
  padding: 0 2px;
  border-radius: 2px;
  display: inline-block;
}
.pagination {
  width: 100%;
  margin-top: 20px;
}
.status_beforeline {
  color: var(--primary);
  font-size: 14px;
  background-color: #f7f7f7;
  padding: 0 2px;
  border-radius: 2px;
  display: inline-block;
}
.status_beforeline {
  color: var(--secondary-text);
  font-size: 14px;
  background-color: var(--gray);
  padding: 0 2px;
  border-radius: 2px;
  display: inline-block;
}
.panel {
  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 20px;
  }
  .condition {
    background-color: var(--white);
    border-radius: 1px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 12px;
    &__info {
      display: flex;
      align-items: center;
      margin-right: 20px;
      &__label {
        color: var(--main-text);
        font-size: 14px;
        margin-right: 12px;
      }
      &__data {
        width: 280px;
      }
    }
  }
  .body {
    padding: 20px;
    background-color: var(--white);
  }
}
.status_online {
  font-size: 11px;
  color: var(--success);
  padding: 1px 2px;
  background-color: var(--light-success);
  display: inline-block;
  border-radius: 2px;
}
.status_outline {
  font-size: 11px;
  color: #aeb2ba;
  padding: 1px 2px;
  background-color: var(--gray);
  display: inline-block;
  border-radius: 2px;
}
.status_beforeline {
  font-size: 11px;
  color: var(--primary);
  padding: 1px 2px;
  background-color: var(--light-primary);
  display: inline-block;
  border-radius: 2px;
}
.project_name {
  cursor: pointer;
}
</style>
